<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

const COMPONENT_API = "https://api.aicoiot.com/componentapi.php";

export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "服务类目",
            items: [],
            userinfo: {},
            appid: "",
            categoryList: [],
            loadingList: false,
            cascaderOptions: [],
            loadingCascader: false,
            addDialogVisible: false,
            addRows: [{ path: null }],
            savingAdd: false,
            deletingKey: "",
        };
    },
    mounted() {
        try {
            this.userinfo =
                JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.appid = this.$route.params.appid;
        this.title = "服务类目";
        this.items = [
            { text: this.$t("menuitems.micoapp.text"), href: "/" },
            { text: this.$t("menuitems.icp.micoapp.list"), href: "/micoapp" },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                href: `/micoapp/${this.appid}`,
            },
            {
                text: "小程序管理",
                href: `/micoapp/${this.appid}#micoapp-wechat-mgmt`,
            },
            { text: "服务类目", active: true },
        ];
        this.fetchCategoryList();
        this.loadCascaderOptions();
    },
    methods: {
        async postCmp(payload) {
            return this.$axios.post(COMPONENT_API, payload, {
                headers: { Openid: this.userinfo.openid },
            });
        },
        wxOk(res) {
            const d = res && res.data;
            return d && Number(d.errcode) === 0;
        },
        wxErrmsg(res) {
            const d = res && res.data;
            return (d && d.errmsg) || "操作失败";
        },
        rowFirstSecond(row) {
            let f =
                row.first_id != null
                    ? row.first_id
                    : row.first != null
                      ? row.first
                      : null;
            let s =
                row.second_id != null
                    ? row.second_id
                    : row.second != null
                      ? row.second
                      : null;
            if (f == null && typeof row.first_class === "number") {
                f = row.first_class;
            }
            if (s == null && typeof row.second_class === "number") {
                s = row.second_class;
            }
            return { f: Number(f), s: Number(s) };
        },
        rowKey(row) {
            const { f, s } = this.rowFirstSecond(row);
            if (!Number.isFinite(f) || !Number.isFinite(s)) return "";
            return `${f}-${s}`;
        },
        categoryDisplayName(row) {
            const n1 =
                row.first_name ||
                row.first_class_name ||
                row.first_cate_name;
            const n2 =
                row.second_name ||
                row.second_class_name ||
                row.second_cate_name;
            if (n1 && n2) return `${n1} > ${n2}`;
            const fc = row.first_class;
            const sc = row.second_class;
            if (
                fc != null &&
                sc != null &&
                typeof fc === "string" &&
                typeof sc === "string"
            ) {
                return `${fc} > ${sc}`;
            }
            const { f, s } = this.rowFirstSecond(row);
            if (Number.isFinite(f) && Number.isFinite(s)) {
                return `一级 ${f} / 二级 ${s}`;
            }
            return "—";
        },
        auditStatusText(row) {
            const st =
                row.audit_status != null
                    ? row.audit_status
                    : row.status;
            const n = Number(st);
            const map = {
                0: "已通过",
                1: "审核中",
                2: "审核失败",
                3: "已通过",
                4: "已拒绝",
            };
            if (map[n]) return map[n];
            if (st === "" || st == null) return "—";
            return String(st);
        },
        buildCascaderOptions(list) {
            if (!Array.isArray(list) || !list.length) return [];
            const level1 = list.filter(
                (c) => c.id !== 0 && Number(c.father) === 0
            );
            level1.sort((a, b) => a.id - b.id);
            return level1
                .map((p) => {
                    const children = list
                        .filter(
                            (c) =>
                                Number(c.father) === p.id && c.id !== p.id
                        )
                        .sort((a, b) => a.id - b.id)
                        .map((ch) => ({
                            value: ch.id,
                            label:
                                ch.name != null && String(ch.name) !== ""
                                    ? ch.name
                                    : `类目 ${ch.id}`,
                        }));
                    if (!children.length) return null;
                    return {
                        value: p.id,
                        label:
                            p.name != null && String(p.name) !== ""
                                ? p.name
                                : `类目 ${p.id}`,
                        children,
                    };
                })
                .filter(Boolean);
        },
        async fetchCategoryList() {
            if (!this.appid) return;
            this.loadingList = true;
            try {
                const res = await this.postCmp({
                    action: "getcategory",
                    appid: this.appid,
                });
                if (this.wxOk(res)) {
                    const list = res.data && res.data.category_list;
                    this.categoryList = Array.isArray(list) ? list.slice() : [];
                } else {
                    this.categoryList = [];
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.categoryList = [];
                this.$message.error("加载失败");
            } finally {
                this.loadingList = false;
            }
        },
        async loadCascaderOptions() {
            if (!this.appid) return;
            this.loadingCascader = true;
            try {
                const res = await this.postCmp({
                    action: "getallcategory",
                    appid: this.appid,
                });
                if (!this.wxOk(res)) {
                    this.cascaderOptions = [];
                    return;
                }
                const list =
                    (res.data &&
                        res.data.categories_list &&
                        res.data.categories_list.categories) ||
                    [];
                this.cascaderOptions = this.buildCascaderOptions(list);
            } catch (e) {
                console.error(e);
                this.cascaderOptions = [];
            } finally {
                this.loadingCascader = false;
            }
        },
        goDetail() {
            this.$router.push({ path: `/micoapp/${this.appid}` });
        },
        onSetMainCategory() {
            this.$message.info(
                "主营类目请在微信公众平台小程序后台「设置 - 基本设置 - 服务类目」中配置。"
            );
        },
        openAddDialog() {
            this.addRows = [{ path: null }];
            this.addDialogVisible = true;
            if (!this.cascaderOptions.length && !this.loadingCascader) {
                this.loadCascaderOptions();
            }
        },
        addCategoryRow() {
            this.addRows.push({ path: null });
        },
        removeAddRow(index) {
            if (this.addRows.length <= 1) return;
            this.addRows.splice(index, 1);
        },
        async submitAddDialog() {
            const cats = [];
            for (let i = 0; i < this.addRows.length; i++) {
                const p = this.addRows[i].path;
                if (p && p.length === 2) {
                    cats.push({
                        first: p[0],
                        second: p[1],
                        certicates: [],
                    });
                }
            }
            if (!cats.length) {
                this.$message.warning("请选择服务类目");
                return;
            }
            if (this.categoryList.length + cats.length > 5) {
                this.$message.warning("服务类目最多 5 个，请减少本次添加条数");
                return;
            }
            this.savingAdd = true;
            try {
                const res = await this.postCmp({
                    action: "addwxxacategory",
                    appid: this.appid,
                    categories: cats,
                });
                if (this.wxOk(res)) {
                    this.$message.success("已提交添加");
                    this.addDialogVisible = false;
                    await this.fetchCategoryList();
                } else {
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.$message.error("提交失败");
            } finally {
                this.savingAdd = false;
            }
        },
        async deleteCategory(row) {
            const { f, s } = this.rowFirstSecond(row);
            if (!Number.isFinite(f) || !Number.isFinite(s)) {
                this.$message.warning("无法识别该类目");
                return;
            }
            const key = `${f}-${s}`;
            try {
                await this.$confirm("确定删除该类目？", "提示", {
                    type: "warning",
                });
            } catch (e) {
                return;
            }
            this.deletingKey = key;
            try {
                const res = await this.postCmp({
                    action: "deletewxxacategory",
                    appid: this.appid,
                    first: f,
                    second: s,
                });
                if (this.wxOk(res)) {
                    this.$message.success("已删除");
                    await this.fetchCategoryList();
                } else {
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.$message.error("删除失败");
            } finally {
                this.deletingKey = "";
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-svc-category-page">
            <div class="card micoapp-svc-category-card border-0 shadow-sm">
                <div class="card-body">
                    <div
                        class="micoapp-svc-category-header d-flex flex-wrap justify-content-between align-items-start"
                    >
                        <div class="mb-3 mb-md-0">
                            <h4 class="micoapp-svc-category-title mb-2">
                                服务类目
                            </h4>
                            <p class="micoapp-svc-category-sub mb-0">
                                服务类目最多添加 5 个；每月可添加次数与额度以微信返回为准。
                            </p>
                        </div>
                        <div
                            class="d-flex flex-wrap align-items-center micoapp-svc-category-actions"
                        >
                            <el-button
                                size="medium"
                                class="micoapp-svc-category-btn-secondary mr-2 mb-2"
                                @click="onSetMainCategory"
                            >
                                设置主营类目
                            </el-button>
                            <el-button
                                type="success"
                                size="medium"
                                class="micoapp-svc-category-btn-primary mb-2"
                                @click="openAddDialog"
                            >
                                添加类目
                            </el-button>
                            <el-button
                                size="medium"
                                class="mb-2 ml-md-2"
                                @click="goDetail"
                            >
                                返回详情
                            </el-button>
                        </div>
                    </div>
                    <el-table
                        v-loading="loadingList"
                        :data="categoryList"
                        class="micoapp-svc-category-table"
                        header-row-class-name="micoapp-svc-category-table-header"
                        style="width: 100%;"
                    >
                        <template slot="empty">
                            <div class="micoapp-svc-category-empty">
                                你还没有添加任何服务类目
                            </div>
                        </template>
                        <el-table-column
                            label="服务类目"
                            min-width="280"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{ categoryDisplayName(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="状态"
                            width="140"
                            align="center"
                        >
                            <template slot-scope="scope">
                                {{ auditStatusText(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="120"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    class="micoapp-svc-category-del"
                                    :loading="
                                        deletingKey === rowKey(scope.row)
                                    "
                                    @click="deleteCategory(scope.row)"
                                >
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog
            title="添加类目"
            :visible.sync="addDialogVisible"
            width="560px"
            append-to-body
            :close-on-click-modal="false"
            custom-class="micoapp-svc-category-dialog"
        >
            <p class="micoapp-svc-category-dialog-hint">
                请根据小程序的服务范围，准确选择类目
            </p>
            <div
                v-for="(row, idx) in addRows"
                :key="'add-cat-' + idx"
                class="micoapp-svc-category-dialog-row d-flex flex-wrap align-items-center mb-3"
            >
                <span class="micoapp-svc-category-dialog-label">服务类目</span>
                <el-cascader
                    v-model="row.path"
                    class="micoapp-svc-category-cascader flex-grow-1"
                    :options="cascaderOptions"
                    :props="{
                        expandTrigger: 'hover',
                        value: 'value',
                        label: 'label',
                        children: 'children',
                    }"
                    filterable
                    clearable
                    placeholder="请选择或者输入关键词搜索"
                />
                <el-button
                    v-if="addRows.length > 1"
                    type="text"
                    class="ml-2"
                    @click="removeAddRow(idx)"
                >
                    移除
                </el-button>
            </div>
            <el-button
                type="text"
                class="micoapp-svc-category-link-add p-0"
                @click="addCategoryRow"
            >
                添加类目
            </el-button>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button
                    type="success"
                    :loading="savingAdd"
                    @click="submitAddDialog"
                >
                    确定
                </el-button>
            </span>
        </el-dialog>
    </Layout>
</template>

<style scoped>
.micoapp-svc-category-page {
    max-width: 960px;
}

.micoapp-svc-category-card {
    border-radius: 8px;
}

.micoapp-svc-category-title {
    font-size: 1.35rem;
    font-weight: 600;
    color: #353535;
    margin: 0;
}

.micoapp-svc-category-sub {
    font-size: 0.875rem;
    color: #888;
    max-width: 420px;
}

.micoapp-svc-category-btn-secondary {
    background: #f5f5f5 !important;
    border-color: #e5e5e5 !important;
    color: #666 !important;
}

.micoapp-svc-category-btn-primary {
    background-color: #07c160 !important;
    border-color: #07c160 !important;
}

.micoapp-svc-category-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.micoapp-svc-category-table >>> .micoapp-svc-category-table-header th {
    background: #f5f5f5 !important;
    color: #333;
    font-weight: 500;
}

.micoapp-svc-category-empty {
    padding: 48px 16px;
    color: #bbb;
    font-size: 0.95rem;
}

.micoapp-svc-category-del {
    color: #576b95 !important;
}

.micoapp-svc-category-dialog-hint {
    color: #999;
    font-size: 0.875rem;
    margin: 0 0 16px 0;
}

.micoapp-svc-category-dialog-label {
    width: 88px;
    flex-shrink: 0;
    color: #333;
    font-size: 0.9rem;
}

.micoapp-svc-category-cascader {
    min-width: 200px;
}

.micoapp-svc-category-link-add {
    color: #576b95 !important;
    font-size: 0.9rem;
}
</style>

<style>
.micoapp-svc-category-dialog .el-dialog__footer {
    text-align: center;
}

.micoapp-svc-category-dialog .el-dialog__footer .el-button--success {
    background-color: #07c160;
    border-color: #07c160;
}
</style>
